import React, { Component } from 'react';
import { Image } from 'react-bootstrap';

class AccountOverviewIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    return (
      <div style={{ paddingLeft: 5 }}>
        <div className="container_card_content_wallets_addresses" onClick={() => { this.props.getWallets(1, 10, this.props.row.coin) }}>
          <div className="container_card_content_display_flex">
            <div className="container_card_content_icon_wallet">
              <Image src={require("../../../CryptoIcons/" + this.props.row.coin + ".svg")} style={{ width: 40 }} />
            </div>
            <div className="container_card_content_name_wallet_prices">
              <p className="container_card_content_name_text_wallet_prices">
               {this.props.row.balance}
              </p>
              <p className="container_card_content_name_text_wallet_balance" > <span style={{ textTransform: "uppercase" }}>{this.props.row.coin}</span> Balance </p>
            </div>
          </div>
          <div className='container_card_divider'/>
          <div className="container_card_content_display_flex">
            <div className="container_card_content_display_flex_divided">
              <p className="container_card_content_name_text_wallet_prices" style={{paddingLeft:15}}> {this.props.row.wallets} / {this.props.planInfo.wallets_per_coin}<span> Wallets</span></p>
              <p className="container_card_content_name_text_wallet_prices" style={{paddingLeft:15}}>{this.props.row.addresses} / {this.props.planInfo.addresses_per_coin} <span> {this.props.traductions.addresses}</span></p>
            </div>
          </div>
        </div>
      </div>
    );
  }

} export default AccountOverviewIndex;
